export default typeof Worker === 'function' ? Worker : class {};
